<template>
    <div class="row mb-3">
        <div class="privatbank-connect-block" v-if="step == 1">
            <p>
                {{ $t('privat_desc_one') }}
            </p>

            <p>{{ $t('privat_desc_two') }}</p>
            <p class="info-tip" v-html="$t('privat_desc_three')"></p>

            <div class="btn-group">
                <button type="button" class="btn btn-blue" @click.prevent="step = 2">{{ $t('Начать') }}</button>
            </div>
        </div>
        <div class="privatbank-connect-form" v-if="step == 2">
            <div class="privat24-web">
                <img src="@/assets/images/privat24-web.png" class="w-50">
            </div>

            <ul class="mt-3">
                <li v-html="$t('privat_step_1_1')"></li>
                <li>{{ $t('privat_step_1_2') }}</li>
                <li>{{ $t('privat_step_1_3') }}</li>
                <li v-html="$t('privat_step_1_4')"></li>
                <li>{{ $t('privat_step_1_5') }}</li>
            </ul>

            <div class="form-container">
                <div class="form-group">
                    <input type="text" class="form-control" v-model="form.card" placeholder="5167 **** **** **** ****">
                </div>

                <div class="text-center">
                    <div class="btn-group">
                        <button type="button" class="btn btn-blue" :disabled="disabledCardButton" @click.prevent="step = 3">{{ $t('Продолжить') }}</button>
                    </div>
                    <a href="#" @click.prevent="step = 1" class="btn-back">{{ $t('Отмена') }}</a>
                </div>
            </div>
        </div>
        <div class="privatbank-connect-form" v-if="step == 3">
            <ul>
                <li>{{ $t('privat_step_2_1') }} <code>127.0.0.1</code></li>
                <li>
                    {{ $t('privat_step_2_2') }}

                    <ul>
                        <li>{{ $t('privat_step_2_2_1') }}</li>
                        <li>{{ $t('privat_step_2_2_2') }}</li>
                        <li>{{ $t('privat_step_2_2_3') }}</li>
                        <li>{{ $t('privat_step_2_2_4') }}</li>
                    </ul>
                </li>
                <li>{{ $t('Нажмите') }} "<b>{{ $t('Далее') }}</b>"</li>
                <li>{{ $t('Подтвердите пароль OTP') }}</li>
                <li v-html="$t('privat_step_2_5')"></li>
            </ul>

            <p v-html="$t('privat_step_2_6')"></p>

            <div class="alert alert-danger invalid-feedback" v-if="hasError('connection')">
                {{ getError('connection') }}
            </div>

            <div class="form-container login-password">
                <div class="form-group">
                    <input type="text" class="form-control" v-model="form.merchant_id" :placeholder="$t('Мерчант ID')">
                </div>
                <div class="form-group">
                    <input type="password" class="form-control" v-model="form.merchant_password" :placeholder="$t('Мерчант пароль')">
                </div>

                <div class="text-center">
                    <div class="btn-group">
                        <button class="btn btn-blue" :disabled="disabledMerchantButton" @click.prevent="store">{{ $t('Сохранить') }}</button>
                    </div>
                    <a href="#" @click.prevent="step = 2" class="btn-back">{{ $t('Назад') }}</a>
                </div>
            </div>
        </div>
        <div class="privatbank-disabled-block" v-if="step === 4">
            <div class="left-side-disable">
                <p>
                    {{ $t('Мы уже выгружаем операции по вашей карте ПриватБанк') }}
                </p>

                <p class="mt-5">
                    <button class="btn btn-blue" @click.prevent="disconnect">{{ $t('Хочу отключить') }}</button>
                </p>
            </div>
            <div class="right-side-disable">
                <img style="max-width: 300px" class="w-100" src="@/assets/images/privat24-logo.png">
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from '../../../../event-bus';

export default {
    data: function() {
        return {
            step: 1,

            form: {
                card: null,

                merchant_id: null,
                merchant_password: null,
            },

            errors: {},
        };
    },

    watch: {
        "form.merchant_id": function() {
            delete this.errors['connection'];
        },
        "form.merchant_password": function() {
            delete this.errors['connection'];
        },
    },

    computed: {
        disabledCardButton() {
            return this.form.card === null || this.form.card === "" || this.form.card === " ";
        },

        disabledMerchantButton() {
            return this.form.merchant_id === null || this.form.merchant_id === "" || this.form.merchant_id === " "
                    || this.form.merchant_password === null || this.form.merchant_password === "" || this.form.merchant_password === " ";
        }
    },

    mounted() {
        this.loadStatus();
    },

    methods: {
        loadStatus() {
            axios.get('/settings/integration/privatbank/status')
                .then(({data}) => {
                    if(data.data.step == 2) {
                        this.step = 4;
                    }
                }).catch(({response}) => {
                    console.log(response);

                    return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Невозможно получить статус'), 'error');
                });
        },

        store() {
            axios.post('/settings/integration/privatbank', this.form)
                .then(({data}) => {
                    this.loadStatus();

                    this.$ga.event('connectPrivatbank', 'connected');
                }).catch(({response}) => {
                    console.log(response);
                    
                    EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error'); 

                    this.errors = response.data.data;
                });
        },

        disconnect() {
            axios.delete('/settings/integration/privatbank')
                .then(({data}) => {
                    this.$ga.event('disconnectPrivatbank', 'disconnected');

                    this.loadStatus();
                }).catch(({response}) => {
                    return EventBus.$emit('show-alert', response.data.message ? response.data.message : $t('Неизвестная ошибка'), 'error');
                });
        },

        hasError(name) {
            return this.errors[name] !== undefined;
        },
        
        getError(name) {
            if(this.hasError(name)) {
                return this.errors[name][0].replace(name, '');
            }

            return "";
        },
    },
}
</script>

<style lang="scss" scoped>
.privatbank-connect-block {
    .info-tip {
        font-size: 14px;
        font-family: 'Proxima Nova Rg';
        color: rgba(#152640, .5);
    }
}

.privatbank-connect-form {
    margin-top: 25px;

    .privat24-web {
        text-align: center;

        img {
            width: 50%;
        }
    }

    .form-container {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;

        .form-group {
            justify-content: center;

            input {
                width: 50%!important;
            }
        }

        &.login-password {
            gap: 16px;

            .form-group {
                width: calc(50% - 8px);

                input {
                    width: 100%!important;
                }
            }

            .btn-group {
                margin-top: 0;
            }
        }

        .btn-group {
            margin-bottom: 10px;
        }

        .btn-back {
            font-size: 12px;
        }
    }
}

.privatbank-disabled-block {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;

    .left-side-disable {
        width: 50%;
        text-align: center;
    }

    .right-side-disable {
        width: 40%;
        margin-left: auto;
    }
}
</style>